import { Outlet, Link } from 'react-router-dom';
import { LogOut, Trees } from 'lucide-react';
import { useAuth, signOut } from '../lib/auth';

export default function AdminShell() {
  const auth = useAuth();

  if (auth.loading) {
    return (
      <div className="flex h-full items-center justify-center text-soft">
        <div className="rw-heading animate-pulse text-xs">Signing in…</div>
      </div>
    );
  }
  if (auth.noAccess) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 p-6 text-center">
        <div className="rw-card max-w-md p-10">
          <Trees className="mx-auto h-8 w-8 text-accent" />
          <h1 className="rw-heading mt-4 text-base text-ink">No access</h1>
          <p className="mt-3 text-sm text-mid">
            {auth.email ? `${auth.email} is signed in but` : 'Your account'} is
            not in the <code className="text-accent">docsend:user</code> group.
            Ask the administrator for access, then sign out and back in.
          </p>
          <button onClick={signOut} className="rw-btn mt-6 w-full">
            Sign out
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-full flex-col">
      <header className="border-b border-white/10">
        <div className="mx-auto flex w-full max-w-6xl items-center gap-4 px-5 py-4">
          <Link to="/" className="flex items-center gap-2.5 text-white">
            <Trees className="h-5 w-5 text-accent" strokeWidth={1.75} />
            <span className="rw-heading text-sm">Redwood</span>
            <span className="rw-heading border-l border-white/25 pl-2.5 text-sm font-light text-soft">
              Deals
            </span>
          </Link>
          <div className="flex-1" />
          <span className="hidden text-xs text-soft sm:block">{auth.email}</span>
          <button
            onClick={() =>
              document.dispatchEvent(new CustomEvent('redwood-apps:open'))
            }
            className="rw-btn-ghost"
            title="All apps"
          >
            Apps
          </button>
          <button onClick={signOut} className="rw-btn-ghost" title="Sign out">
            <LogOut className="h-3.5 w-3.5" />
          </button>
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-5 py-8">
        <Outlet />
      </main>
    </div>
  );
}
